import { useDispatch } from 'react-redux'
import { Button } from 'components'
import { setModal } from 'slices/modal'
import { STATICS } from 'statics'
import { MODAL_KEYS } from 'app-constants'
import './style.scss'

export function GoToRedirectLink({
  url,
  buttonLabel = 'Ir para o Site',
  description = 'Você será redirecionado para um site externo',
}) {
  const dispatch = useDispatch()

  function handlePaymentClick() {
    window.open(url)
    dispatch(setModal({ key: MODAL_KEYS.NONE }))
  }

  return (
    <div className='redirect-container-modal'>
      <div className='container-icon'>
        <STATICS.CREDIT_WARNING />
      </div>
      <span className='text'>{description}</span>
      <div className='container-button'>
        <Button onClick={handlePaymentClick} color='primary' className='button'>
          {buttonLabel} {'>'}
        </Button>
      </div>
    </div>
  )
}
